import { site } from "@/data/site";
import { WhatsappIcon } from "./BrandIcons";
import { trackConversion } from "@/lib/track";

export function WhatsAppButton() {
  return (
    <a
      href={site.whatsappMessage}
      onClick={() => trackConversion("whatsapp_klik")}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-5 left-4 z-50 flex items-center gap-2 rounded-full bg-white px-4 py-3 font-semibold text-secondary shadow-lg ring-1 ring-black/5 transition hover:scale-105 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-secondary sm:left-5"
      aria-label={`WhatsApp ons op ${site.whatsapp}`}
    >
      <WhatsappIcon className="size-6" />
      <span className="hidden sm:inline">WhatsApp ons</span>
    </a>
  );
}
